import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { Notification } from 'features/GlobalNotification/components/Notification';

export const StyledLink = styled(Link)`
  color: ${colors.blue600};

  &:hover {
    text-decoration: underline;
    color: ${colors.blue600};
  }
`;

export const StyledNotification = styled(Notification)`
  left: 50%;
  transform: translateX(-50%);
`;
